import { Color } from "flavr-math";
import { Renderable } from "../renderable/Renderable";
import { modelPool, modelToAbsolutePath } from "@modules/model";
const tempColor = new Color();
export class PrimitiveMeshRenderable extends Renderable {
    constructor() {
        super(...arguments);
        this.type = PrimitiveMeshRenderable.typestatic;
    }
    destroy() {
        if (this.instance === undefined)
            return;
        this.instance.destroy();
        this.instance = undefined;
        if (this.facet && this.facet.material && this.facet.material.castShadow) {
            this.owner.renderer.updateShadowForModel(this.owner.modelUID);
        }
    }
    getGeometry() {
        if (!this.instance)
            return;
        return {
            geometry: this.instance.geometry,
            mesh: this.instance.mesh
        };
    }
    setVisible(visible) {
        if (this.instance === undefined) {
            throw new Error("We expect this.instance to be defined.");
        }
        this.instance.setVisible(visible);
        if (this.facet && this.facet.material.castShadow) {
            this.owner.renderer.updateShadowForModel(this.owner.modelUID);
        }
    }
    setClipFade(target) {
        if (this.instance === undefined) {
            throw new Error("We expect this.instance to be defined.");
        }
        this.instance.setClipFade(target);
    }
    updateFacet(facet) {
        var _a, _b, _c;
        if (this.facet === undefined || this.facet.shape !== facet.shape || this.facet.material !== facet.material) {
            if (this.instance)
                this.instance.destroy();
            this.instance = this.owner.renderer.createInstancedPrimitiveMesh(this.owner.modelUID, facet.shape, facet.material);
            this.instance.setPosition(this.owner.worldPosition);
            this.instance.setOrientation(this.owner.worldOrientation);
            this.instance.setScale(this.owner.worldScale);
            this.instance.setColor(tempColor.set(facet.color));
            (_a = this.instance.mesh) === null || _a === void 0 ? void 0 : _a.position.copy(this.owner.worldPosition);
            (_b = this.instance.mesh) === null || _b === void 0 ? void 0 : _b.quaternion.copy(this.owner.worldOrientation);
            (_c = this.instance.mesh) === null || _c === void 0 ? void 0 : _c.scale.copy(this.owner.worldScale);
            const mesh = this.instance.mesh;
            if (mesh !== undefined) {
                const model = modelPool.getModelOrThrow(this.owner.modelUID);
                mesh.name = model.getName();
                mesh.userData = {
                    path: modelToAbsolutePath(model)
                };
            }
            if (this.facet && this.facet.material.castShadow) {
                this.owner.renderer.updateShadowForModel(this.owner.modelUID);
            }
            this.setClipFade(this.owner.clipFade);
        }
        else if (this.instance) {
            this.instance.setColor(tempColor.set(facet.color));
        }
    }
    updateTransform() {
        if (this.instance === undefined) {
            throw new Error("We expect this.instance to be defined.");
        }
        this.instance.setPosition(this.owner.worldPosition);
        this.instance.setOrientation(this.owner.worldOrientation);
        this.instance.setScale(this.owner.worldScale);
        const mesh = this.instance.mesh;
        if (mesh !== undefined) {
            mesh.position.copy(this.owner.worldPosition);
            mesh.quaternion.copy(this.owner.worldOrientation);
            mesh.scale.copy(this.owner.worldScale);
            mesh.matrixWorldNeedsUpdate = true;
        }
        if (this.facet && this.facet.material.castShadow) {
            this.owner.renderer.updateShadowForModel(this.owner.modelUID);
        }
    }
}
PrimitiveMeshRenderable.typestatic = "Primitive";
